import {_urlBlog,request} from "../api";
import {BLOG_CONSTS} from "../constants";


export const GetEvent = ({
                                type = 'EVENT',
                                reset = true,
                                offset = 0,
                                text,
                                limit = 5,
                            } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}&type=${type}`;
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.EVENT_GET,
                    payload: data
                })
            })
    };
};

export const GetBlog = ({
                              offset = 0,
                              type ,
                              limit = 12,
                          } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}&type=${type}`;
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.BLOG_GET,
                    payload: data
                })
            })
    };
};

export const GetBlogCount = ({
                                 text,
                                 type,
                             } = {}) => {
    let url = `${_urlBlog}/count`;
    text && (url += `?text=${text}`);
    type && (url += `?type=${type}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.GET_BLOG_COUNT,
                    payload: data
                })
            })
    };
};

export const GetSearch = ({
                                offset = 0,
                                text,
                                limit = 6,
                            } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}`;
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.GET_SEARCH,
                    payload: data
                })
            })
    };
};

export const GetVideo = ({
                                type = 'VIDEO',
                                reset = true,
                                offset = 0,
                                text,
                                limit = 6,
                            } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}&type=${type}`;
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.GET_VIDEO,
                    payload: data
                })
            })
    };
};

export const GetTravel = ({
                                type = 'TRAVELING',
                                reset = true,
                                offset = 0,
                                text,
                                limit = 4,
                            } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}&type=${type}`;
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.GET_TRAVEL,
                    payload: data
                })
            })
    };
};

export const GetProject = ({
                                type = 'PROJECT',
                                reset = true,
                                offset = 0,
                                text,
                                limit = 4,
                            } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}&type=${type}`;
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.GET_PROJECT,
                    payload: data
                })
            })
    };
};

export const GetNews = ({
                                offset = 0,
                                text,
                                limit = 5,
                            } = {}) => {
    let url = `${_urlBlog}?offset=${offset}&limit=${limit}`;
    text && (url += `&text=${text}`);
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                data && dispatch({
                    type: BLOG_CONSTS.NEWS_GET,
                    payload: data
                })
            })
    };
};

export const GetBlogById = (slug) => {
    let url = `${_urlBlog}/${slug}`;
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                return data
            })
    };
};

export const GetBlogMedias = (id) => {
    let url = `${_urlBlog}/media/${id}`;
    const requestData = {
        url,
        method: "GET",
        languageFlag: true
    };

    return dispatch => {
        return request(requestData)
            .then((res) => {
                const data = res && res.data;
                return data
            })
    };
};